module.exports = __webpack_public_path__ + "assets/images/ca99af7855f5ce192bb28a1b36b96271.png";